"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("../../utils/classnames"));
require("./TypingIndicator.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TypingIndicator = function TypingIndicator(_ref) {
  var contained = _ref.contained,
    small = _ref.small;
  var classes = (0, _classnames["default"])({
    contained: contained,
    small: small
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-typing-indicator ".concat(classes)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ti-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ti-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ti-dot"
  }));
};
TypingIndicator.propTypes = {
  contained: _propTypes["default"].bool,
  small: _propTypes["default"].bool
};
var _default = exports["default"] = TypingIndicator;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/TypingIndicator/TypingIndicator.js
// module id = 592
// module chunks = 0